export default "__VITE_ASSET__B$ocHJXR__"